module.exports = __webpack_public_path__ + "img/localizationPlanTitle@2x.acbc385b.png";